import { Injectable } from '@angular/core';

@Injectable()
export class TokenService {    
    token: string = "";

    constructor() { 
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));        
        this.token=currentUser && currentUser.token;
    }

    getToken(){
        return this.token;
    }
    
    setToken(token: string){
        this.token = token;
    }
}



// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/components/auth/token.service.ts